import { render, staticRenderFns } from "./VehicleAssignment.vue?vue&type=template&id=67af69d7"
import script from "./VehicleAssignment.vue?vue&type=script&lang=js"
export * from "./VehicleAssignment.vue?vue&type=script&lang=js"
import style0 from "./VehicleAssignment.vue?vue&type=style&index=0&id=67af69d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports